import 'react';
import { embedMarketingTrackingIntoURL } from '@lendi-jam/jam-link';
import { Heading, Link as Link$1, Body } from '@lendi-ui/typography';
import { jsxs, jsx } from 'react/jsx-runtime';
import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import { gte } from '@lendi-ui/breakpoint';
import { Button as Button$1 } from '@lendi-ui/button';
import { color } from '@lendi-ui/color';
import Container from '@lendi-ui/container';
import { grid, unit } from '@lendi-ui/grid';
import { py, mt, mb, mr, px } from '@lendi-ui/spacing';
import styled from 'styled-components';

var Step$1 = function Step(_ref) {
  var stepNum = _ref.stepNum;
  return /*#__PURE__*/jsxs("svg", {
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/jsx("title", {
      children: "Group 8"
    }), /*#__PURE__*/jsx("g", {
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/jsx("g", {
        transform: "translate(-65.000000, -160.000000)",
        children: /*#__PURE__*/jsx("g", {
          transform: "translate(65.000000, 80.000000)",
          children: /*#__PURE__*/jsxs("g", {
            transform: "translate(0.000000, 80.000000)",
            children: [/*#__PURE__*/jsx("circle", {
              id: "Oval",
              fill: "#FFFFFF",
              cx: "16",
              cy: "16",
              r: "16"
            }), /*#__PURE__*/jsx("text", {
              fontFamily: "Cabin-Bold, Cabin",
              fontSize: "18",
              fontWeight: "bold",
              "line-spacing": "24",
              fill: "#0D5A6D",
              children: /*#__PURE__*/jsx("tspan", {
                x: "12.679",
                y: "21",
                children: stepNum
              })
            })]
          })
        })
      })
    })]
  });
};

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13;
var Wrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  background-color: ", ";\n"])), py('xxxl'), function (_ref) {
  var variant = _ref.variant;
  return variant === 'white' ? 'white' : variant === 'grey' ? '#f1f1f1' : color('primary.50');
});
var Content = styled(Container)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  justify-content: space-between;\n  flex-direction: row-reverse;\n  ", "\n"])), grid({
  gutter: 'nil'
}));
var Image = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n  background-position: center bottom;\n  background-repeat: no-repeat;\n  background-image: url('", "');\n  width: 100%;\n  background-size: cover, contain;\n  display: ", ";\n\n  ", "\n  ", "\n  ", "\n  ", "\n"])), unit({
  size: {
    lg: 5 / 12,
    md: 1
  }
}), function (_ref2) {
  var src = _ref2.src;
  return src;
}, function (_ref3) {
  var hideImageOnMobile = _ref3.hideImageOnMobile;
  return hideImageOnMobile ? 'none' : 'block';
}, gte('xs')(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    height: 320px;\n    ", "\n  "])), mt('xxl')), gte('sm')(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    height: 350px;\n    margin-top: 64px\n  "]))), gte('md')(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    height: 450px;\n  "]))), gte('lg')(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    ", "\n    display: block;\n    height: unset;\n    margin-bottom: 50px;\n  "])), mt('xxxl')));
var Text = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  ", "\n  display: flex;\n  flex-direction: column;\n"])), unit({
  size: {
    lg: 6 / 12,
    md: 1
  }
}));
var Title = styled(Heading)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  ", "\n"])), mb('xl'));
var Step = styled.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  display: flex;\n\n  :not(:last-child) {\n    ", "\n  }\n\n  div {\n    ", "\n  }\n\n  p {\n    margin: 0;\n  }\n"])), mb('md'), mr('md'));
var ButtonContainer = styled.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  ", "\n  display:flex;\n  align-items: center;\n"])), mt('sm'));
var Link = styled(Link$1)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  text-decoration: none;\n  ", ";\n"])), px('xl'));
var Button = styled(Button$1)(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  ", ";\n"])), px('md'));

var GenericTextImageLayout = function GenericTextImageLayout(_ref) {
  var _image$fluid;
  var heading = _ref.heading,
    hideImageOnMobile = _ref.hideImageOnMobile,
    image = _ref.image,
    primaryButtonLink = _ref.primaryButtonLink,
    primaryButtonText = _ref.primaryButtonText,
    secondaryButtonLink = _ref.secondaryButtonLink,
    secondaryButtonText = _ref.secondaryButtonText,
    steps = _ref.steps,
    variant = _ref.variant;
  return /*#__PURE__*/jsx(Wrapper, {
    variant: variant,
    children: /*#__PURE__*/jsxs(Content, {
      children: [/*#__PURE__*/jsxs(Text, {
        children: [/*#__PURE__*/jsx(Title, {
          size: "lg",
          children: heading
        }), steps.map(function (_ref2, index) {
          var title = _ref2.title,
            description = _ref2.description;
          return /*#__PURE__*/jsxs(Step, {
            children: [/*#__PURE__*/jsx("div", {
              children: /*#__PURE__*/jsx(Step$1, {
                stepNum: index + 1
              })
            }), /*#__PURE__*/jsxs("div", {
              children: [/*#__PURE__*/jsx(Heading, {
                size: "xs",
                children: /*#__PURE__*/jsx("strong", {
                  children: title
                })
              }), /*#__PURE__*/jsx(Body, {
                size: "md",
                children: description
              })]
            })]
          }, index);
        }), /*#__PURE__*/jsxs(ButtonContainer, {
          children: [primaryButtonText && primaryButtonLink && /*#__PURE__*/jsx(Button, {
            href: embedMarketingTrackingIntoURL(primaryButtonLink),
            backgroundColor: "blue",
            variant: "primary",
            size: "lg",
            children: primaryButtonText
          }), secondaryButtonText && secondaryButtonLink && /*#__PURE__*/jsx(Link, {
            size: "xs",
            color: "primary.500",
            href: embedMarketingTrackingIntoURL(secondaryButtonLink),
            children: secondaryButtonText
          })]
        })]
      }), /*#__PURE__*/jsx(Image, {
        src: (_image$fluid = image.fluid) === null || _image$fluid === void 0 ? void 0 : _image$fluid.src,
        hideImageOnMobile: hideImageOnMobile
      })]
    })
  });
};

export { GenericTextImageLayout as default };
